import React from 'react';

export var RewindIcon = function RewindIcon(props) {
  return React.createElement(
    "svg",
    {
      "data-qa": "RewindIcon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "100%",
      height: "100%",
      preserveAspectRatio: "none",
      viewBox: "0 0 1060 1060"
    },
    React.createElement("path", {
      fill: props.fillColor,
      d: "M 400 200 l 0 -139 c 0 -23 -27 -34 -42 -18 l -190 190 c -10 10 -10 25 0 35 l 189 190 c 16 15 43 4 43 -18 l 0 -140 c 187 0 334 171 293 365 c -23 113 -115 205 -228 228 c -179 38 -338 -85 -362 -250 c -3 -24 -24 -43 -49 -43 c -30 0 -54 27 -50 57 c 31 219 240 382 477 336 c 156 -31 281 -156 312 -312 c 49 -257 -146 -481 -393 -481 Z"
    })
  );
};